export interface LocationCopy {
    title: string
    description: string
    stateLabel: string
}

export const generalMedicineLocationCopy: LocationCopy = {
    title: 'Which state are you in?',
    description:
        "Your state determines which care options and providers are available to you. For virtual visits, choose the state you'll be in during your visit.",
    stateLabel: '',
}
